module.exports = __webpack_public_path__ + "img/yz_5@2x.1fc40538.png";